(() => {
  if (window.__inlineVideoInit) return;
  window.__inlineVideoInit = true;

  function activate(wrapper) {
    if (wrapper.dataset.inlineVideoActive === "1") return;
    let sources;
    try {
      sources = JSON.parse(wrapper.dataset.videoSources || "[]");
    } catch {
      return;
    }
    if (!sources.length) return;

    wrapper.dataset.inlineVideoActive = "1";

    const video = document.createElement("video");
    video.controls = true;
    video.autoplay = true;
    video.playsInline = true;
    video.preload = "auto";
    const posterEl = wrapper.querySelector("img");
    if (posterEl && posterEl.currentSrc) video.poster = posterEl.currentSrc;

    sources.forEach((s) => {
      if (!s || !s.url) return;
      const source = document.createElement("source");
      source.src = s.url;
      if (s.mime_type) source.type = s.mime_type;
      video.appendChild(source);
    });

    wrapper.replaceChildren(video);

    const p = video.play();
    if (p && typeof p.catch === "function") p.catch(() => {});
  }

  document.addEventListener("click", (e) => {
    const wrapper = e.target.closest("[data-inline-video]");
    if (!wrapper || wrapper.dataset.inlineVideoActive === "1") return;
    e.preventDefault();
    activate(wrapper);
  });

  document.addEventListener(
    "play",
    (e) => {
      const current = e.target;
      if (!(current instanceof HTMLVideoElement)) return;
      document.querySelectorAll("video").forEach((video) => {
        if (video !== current && !video.paused) video.pause();
      });
    },
    true,
  );
})();
